/* eslint-disable max-len */
import { IReportRow } from '../types/reports';
import { toFloat } from './text';
import { formatAmount } from './formatAmount';

export const getInputsCount = (tableView: IReportRow[]) => {
  let fieldsCount = 0;

  Object.values(tableView).forEach((row) => {
    if (!row.active || !(row.tabIndex || row.subField?.tabIndex)) return;

    if (row.tabIndex) fieldsCount += 1;
    if (row.subField?.tabIndex) fieldsCount += 1;
    if (row.getPopoverContent) fieldsCount += 1;
  });

  return fieldsCount;
};

export const calculateUip = (loanAmount: number): number => {
  const formatedAmount = formatAmount(loanAmount * 0.0175)

  return parseFloat(formatedAmount)
}

export const getAprRelatedCostValue = (aprRelatedClosingCost: any) => {
  if (typeof aprRelatedClosingCost === 'object') return aprRelatedClosingCost?.value || 0;

  if (typeof aprRelatedClosingCost === 'string' || typeof aprRelatedClosingCost === 'number') return aprRelatedClosingCost;

  return 0;
};

export const calculateAPR = (interest: number, aprRelatedCostValue: number, loanAmount: number, loanPeriodInYears: number) =>
  ((interest + aprRelatedCostValue) / loanAmount / (loanPeriodInYears * 365 + Math.ceil(loanPeriodInYears / 4))) * 365 * 100;


// TODO: Check this formula with new calculateAPR formula
export const calculateAPRFromLoan = (loan: any) => {
  const { loanAmount, interestRate, aprRelatedClosingCost, loanPeriodInYears } = loan;

  if (!loanAmount?.value || !interestRate?.value || !loanPeriodInYears?.value) return '0';

  const aprRelatedCostValue = getAprRelatedCostValue(aprRelatedClosingCost);

  if (!aprRelatedCostValue) return '0';

  const interestRateValue = toFloat(interestRate.value) / 100;

  const interest = (toFloat(loanAmount.value) + aprRelatedCostValue) * interestRateValue * toFloat(loanPeriodInYears.value);

  const apr = calculateAPR(interest, aprRelatedCostValue, loanAmount.value, loanPeriodInYears.value);

  return Number.isNaN(apr) ? '0' : apr.toFixed(3);
};
